import api from "./core";

export default {
  async query(eocId) {
    return api.post(`api/portal/ScheduledMedication/${eocId}`);
  }
};
